module.exports = __webpack_public_path__ + "media/images/icons/social/facebook-790642551cd99bb66a7ede807365080f.png";